import { Client } from "@microsoft/microsoft-graph-client";
import { getAccountByTenantId } from "../../utils/accountUtils";

const fetchAbbreviations = async (instance, accounts, tenantId) => {
  try {
    const account = accounts[0];
    const accessToken = await instance.acquireTokenSilent({
      scopes: ["https://graph.microsoft.com/.default"],
      account: account,
    });

    const client = Client.init({
      authProvider: (done) => {
        done(null, accessToken.accessToken);
      },
    });

    const baseUrl = `${process.env.REACT_APP_GRAPH_API_URL}/sites/${process.env.REACT_APP_SP_SITE_ID}/lists/${process.env.REACT_APP_ABBREVIATIONS_LIST_ID}/items`;
    let nextLink = `${baseUrl}?$expand=fields`;
    let allAbbreviations = {};

    while (nextLink) {
      const response = await client.api(nextLink).get();
      
      // Process each item in the current page
      response.value.forEach((item) => {
        const title = item.fields.Title;
        if (!allAbbreviations[title]) {
          allAbbreviations[title] = [];
        }
        
        allAbbreviations[title].push({
          from: item.fields.field_1,
          to: item.fields.field_2
        });
      });

      // Check if there's a next page
      nextLink = response["@odata.nextLink"] || null;
    }

    return allAbbreviations;
  } catch (error) {
    console.error("Error fetching abbreviations:", error);
    throw new Error("Failed to fetch abbreviations");
  }
};

export const addNewAbbreviationItem = async (instance, accounts, tenantId, payload) => {
  try {
    const account = getAccountByTenantId(accounts, tenantId);
    const response = await instance.acquireTokenSilent({
      scopes: ["https://graph.microsoft.com/.default"],
      account: account,
    });

    const url = `${process.env.REACT_APP_GRAPH_API_URL}/sites/${process.env.REACT_APP_SP_SITE_ID}/lists/${process.env.REACT_APP_ABBREVIATIONS_LIST_ID}/items`;
    
    const result = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${response.accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        fields: {
          Title: payload.Title,
          field_1: payload.field_1,
          field_2: payload.field_2,
          field_3: payload.field_3
        }
      })
    });

    if (!result.ok) {
      throw new Error(`Failed to add new abbreviation item: ${result.statusText}`);
    }

    return await result.json();
  } catch (error) {
    console.error("Error adding new abbreviation item:", error);
    throw error;
  }
};

export default fetchAbbreviations; 